import { Alert, Button, Form, Input } from "antd";
import React, { useContext } from "react";
import AuthContext from "../../context/AuthContext";
import companyLogo from "../../utils/company/assets/company_logo.svg";

interface DemoValues {
  name: string;
  company: string;
  email: string;
}

const ArrowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M5 12h14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    <path d="m12 5 7 7-7 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const DemoForm = () => {
  const { authLoading, authError, handleLoginDemo } = useContext(AuthContext);
  const [form] = Form.useForm<DemoValues>();

  const handleFinish = ({ email }: DemoValues) => {
    handleLoginDemo(email);
  };

  return (
    <>
      <div className="login__top-link">
        Already registered?{" "}
        <button
          type="button"
          onClick={() => window.location.replace("https://collectpro.quattroapps.app")}
        >
          Sign in
        </button>
      </div>

      <div className="login__panel">
        <img src={companyLogo} alt="CollectPRO" className="login__client-logo" />
        <h2 className="login__title">Request a demo</h2>
        <p className="login__subtitle">
          Tell us where to send your CollectPRO demo access.
        </p>

        <Form<DemoValues>
          form={form}
          layout="vertical"
          requiredMark
          onFinish={handleFinish}
          autoComplete="on"
          className="login__form"
        >
          <Form.Item
            label="Your name"
            name="name"
            className="login__form-item"
            rules={[{ required: true, message: "Please enter your name" }]}
          >
            <Input placeholder="Your name" autoComplete="name" aria-required="true" />
          </Form.Item>

          <Form.Item
            label="Company name"
            name="company"
            className="login__form-item"
            rules={[{ required: true, message: "Please enter your company name" }]}
          >
            <Input placeholder="Company name" autoComplete="organization" aria-required="true" />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            className="login__form-item"
            rules={[
              {
                required: true,
                type: "email",
                message: "Please enter a valid email",
              },
            ]}
          >
            <Input placeholder="you@company.com" autoComplete="email" aria-required="true" />
          </Form.Item>

          {authError.status && (
            <Alert
              type="error"
              showIcon
              message={authError.message}
              className="login__alert"
            />
          )}

          <Form.Item className="login__submit-item">
            <Button
              htmlType="submit"
              type="primary"
              block
              loading={authLoading}
              className="login__form-button"
              disabled={authLoading}
            >
              <span>Request demo</span>
              <ArrowIcon />
            </Button>
          </Form.Item>
        </Form>

        <div className="login__demo-card login__demo-card--sales">
          <div className="login__demo-icon" aria-hidden="true">
            Q
          </div>
          <div className="login__demo-copy">
            <strong>Need help choosing a plan?</strong>
            <span>Talk with the Quattro Software sales team.</span>
          </div>
          <a href="https://www.quattroapps.com" target="_blank" rel="noreferrer">
            Sales
            <ArrowIcon />
          </a>
        </div>
      </div>
    </>
  );
};
